import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";


const CAT = "persetujuan-transfusi-inkompatibel";

async function create(data) {
  const response = await http.postData(`/suket/${CAT}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response;
}

async function update(id, data) {
  const response = await http.putData(`/suket/${CAT}/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/suket/${CAT}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function find(id: number) {
  const response = await http.getData(`/suket/${CAT}/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/suket/${CAT}/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

async function sign(id: number, data) {
  const response = await http
    .postData(`/suket/${CAT}/${id}/signature`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

function print(id) {
  window.open(`${http.getAPI()}/suket/${CAT}/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  getByRegister,
  find,
  destroy,
  sign,
  print
};
